import { Horoscope, Origin } from "circular-natal-horoscope-js";

// Calculate all planetary positions for a given birth data
export function calculateAllPositions(birthData: {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
  latitude: number;
  longitude: number;
}) {
  const origin = new Origin({
    year: birthData.year,
    month: birthData.month,
    date: birthData.day,
    hour: birthData.hour,
    minute: birthData.minute,
    latitude: birthData.latitude,
    longitude: birthData.longitude,
  });

  const horoscope = new Horoscope({
    origin: origin,
    houseSystem: "placidus",
    zodiac: "tropical",
    aspectPoints: ["bodies", "points", "angles"],
    aspectWithPoints: ["bodies", "points", "angles"],
    aspectTypes: ["major", "minor"],
    customOrbs: {},
    language: "en",
  });

  const celestial_points = horoscope.CelestialPoints;
  const celestial_bodies = horoscope.CelestialBodies;
  const celestial_ascendant = horoscope.Ascendant;
  const celestial_aspects = horoscope.Aspects;
  const cusps = horoscope.Houses;

  const positions: { [key: string]: any } = {};
  
  positions.celestial_points = celestial_points;
  positions.celestial_bodies = celestial_bodies;
  positions.celestial_ascendant = celestial_ascendant;
  positions.celestial_aspects = celestial_aspects;
  positions.cusps = cusps;
  
  return positions;
} 